export default __webpack_public_path__ + "static/media/404.6ef66d18.svg";